import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import Divider from '@material-ui/core/Divider'
import pink from '@material-ui/core/colors/pink'
import GridWrapper from './GridWrapper'

const styles = theme => ({
  flex: {
    flex: 1,
    textDecoration: 'none',
    fontWeight: 300,
  },
  menuButton: {
    marginLeft: -12,
  },
  button: {
    marginLeft: 10,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },
  paper: {
    background: 'transparent',
    paddingTop: 10,
    paddingBottom: 10,
    display: 'flex',
    justifyContent: 'space-between',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    color: 'white',
    float: 'left',
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  label: {
    color: 'white',
  },
  select: {
    color: 'white',
  },
  form: {
    display: 'inline',
    float: 'left',
    backgroundColor: pink[500],
  },
  formWrapper: {
    padding: 5,
    overflow: 'hidden',
  },
})

class Jumbotron extends Component {
  render () {
    const {classes, variant, bgImage, type, message, showSelect, selected, onChange} = this.props
    return (
      <GridWrapper variant={variant} bgImage={bgImage}>
        <Grid item xs={12}>
          <Paper className={classes.paper} elevation={0}>
            <div>
              <Typography color="inherit" variant="display2"><FormattedMessage id={type} /></Typography>
              <Typography color="inherit" variant="subheading"><FormattedMessage id={message} /></Typography>
            </div>
            {showSelect &&
              <Paper className={classes.formWrapper} elevation={0}>
                <form autoComplete="off" className={classes.form}>
                  <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="game" className={classes.label}><FormattedMessage id="selectGame" /></InputLabel>
                    <Select
                      value={selected}
                      onChange={onChange}
                      input={<Input name="iFrame" id="game" />}
                      color="inherit"
                      className={classes.select}
                    >
                      <MenuItem value="openBaccarat">Baccarat</MenuItem>
                      <MenuItem value="openBlackjack">BlackJack</MenuItem>
                      <MenuItem value="openCaribbeanStud">Stud Poker</MenuItem>
                      <MenuItem value="openCasinoWar">Casino War</MenuItem>
                      <MenuItem value="openCrazyPoker">Crazy Poker</MenuItem>
                      <MenuItem value="openKeepEmPoker">Keep Em</MenuItem>
                      <MenuItem value="openPaiGow">PaiGow</MenuItem>
                      <MenuItem value="openPoker3">Poker Three</MenuItem>
                      <MenuItem value="openRedDog">Red Dog</MenuItem>
                      <Divider />
                      <MenuItem value="openRouletteAmerican">American</MenuItem>
                      <MenuItem value="openRouletteEuropean">European</MenuItem>
                      <Divider />
                      <MenuItem value="openSlotSaloon">Saloon</MenuItem>
                      <MenuItem value="openSlotJungle">Jungle</MenuItem>
                      <MenuItem value="openSlotCritters">Critters</MenuItem>
                      <MenuItem value="openSlotFruitastic">Fruitastic</MenuItem>
                      <MenuItem value="openSlotDogFather">Dog Father</MenuItem>
                      <MenuItem value="openSlotFrodi">Frodi</MenuItem>
                      <Divider />
                      <MenuItem value="openVPJacksOrBetter">Jacks Or Better</MenuItem>
                      <MenuItem value="openVPTensOrBetter">Tens Or Better</MenuItem>
                      <MenuItem value="openVPAllAmerican">All American</MenuItem>
                      <Divider />
                      <MenuItem value="openKenoCannon">Keno Cannon</MenuItem>
                    </Select>
                  </FormControl>
                </form>
              </Paper>
            }
          </Paper>
        </Grid>
      </GridWrapper>
    )
  }
}

Jumbotron.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Jumbotron)


// WEBPACK FOOTER //
// ./src/components/Jumbotron.js